import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common/common';
import form from './modules/common/form';
import bankcardList from './modules/personalCenter/bankcardList';
import fileUpload from './modules/common/fileUpload';
import modal from './modules/common/modal';
import index from './modules/index/index';
import products from './modules/products/products';
import productDetails from './modules/products/productDetails';
import user from './modules/user/user';
import myInfo from './modules/personalCenter/myInfo';
import repaymentInfo from './modules/personalCenter/repaymentInfo';
import wholeRepay from './modules/personalCenter/wholeRepay';
import realNameAuth from './modules/personalCenter/realNameAuth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: [common, form, bankcardList, fileUpload, modal, index, products, productDetails, user, myInfo, repaymentInfo, wholeRepay, realNameAuth],
  strict: process.env.NODE_ENV !== 'production'
});



// WEBPACK FOOTER //
// ./src/vuex/store.js